var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"store-locale-flag-icon"},[_c(_setup.AzButton,{staticClass:"desktop-only store-locale-flag-icon__lang store-locale-flag-icon__lang--selected",on:{"click":_setup.toggleStoreSwitcherModal}},[_c(_setup.LocaleIcon,{attrs:{"country-code":_setup.currentCountry}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }